import { useEffect, useState } from "react";
import WISTIA_CONFIG from "@/config/wistia.config";

interface ThumbnailData {
  thumbnailUrl: string | null;
  aspectRatio: number | null;
}

export default function useWistiaThumbnail(
  videoId: string | undefined,
  providedThumbnailUrl: string | undefined,
  shouldFetch: boolean
): ThumbnailData {
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null);
  const [aspectRatio, setAspectRatio] = useState<number | null>(null);

  useEffect(() => {
    if (!shouldFetch || !videoId || providedThumbnailUrl) {
      return;
    }

    const fetchThumbnail = async () => {
      try {
        const mediaUrl = `${WISTIA_CONFIG.MEDIA_BASE_URL}/${encodeURIComponent(videoId)}`;
        const oembedUrl = `${WISTIA_CONFIG.OEMBED_API_BASE}?url=${encodeURIComponent(mediaUrl)}`;

        const response = await fetch(oembedUrl);

        if (response.ok) {
          const data = await response.json();
          if (data.thumbnail_url) {
            setThumbnailUrl(data.thumbnail_url);
          }

          if (
            typeof data.width === "number" &&
            typeof data.height === "number" &&
            data.width > 0 &&
            data.height > 0
          ) {
            setAspectRatio(data.width / data.height);
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch Wistia thumbnail:", error);
      }
    };

    fetchThumbnail();
  }, [videoId, providedThumbnailUrl, shouldFetch]);

  return { thumbnailUrl, aspectRatio };
}
